// extracted by mini-css-extract-plugin
export default {"mistakeBlock":"NotFound_mistakeBlock__QgQOM"};